import { Component, registerComponent } from 'js/component.js';
import Selectr from 'mobius1-selectr';
import 'vendor/selectr/selectr.less';

const componentName = 'cta-dropdown';

/**
 * CTA Dropdown
 */
class CTADropdown extends Component {
    elements = {
        selectBox: this.element.querySelector('select'),
    };

    localStorageAffinities = JSON.parse(
        window.localStorage.getItem('affinity'),
    );

    /**
     * Gets value for the select placeholder.
     */
    getPlaceholderValue() {
        const { selectBox } = this.elements;
        return this.isKnownUser()
            ? this.getAffinityValue()
            : selectBox.dataset.unknownUserPlaceholder;
    }

    /**
     * Initializes Selectr on the select
     */
    useCustomSelect = () => {
        if (this.elements.selectBox) {
            const selectrOptions = {
                placeholder: this.getPlaceholderValue(),
                defaultSelected: false,
            };

            this.selectInstance = new Selectr(
                this.elements.selectBox,
                selectrOptions,
            );
        }
    };

    /**
     * Add Event Listeners
     */
    addEventListeners = () => {
        this.elements.selectBox.addEventListener('change', () => {
            const { value } = this.elements.selectBox;
            const name = this.elements.selectBox.options[
                this.elements.selectBox.selectedIndex
            ].text;
            this.pushToDataLayer(value, name);
        });
    };

    /**
     *
     * Get affinity category
     */
    getAffinityCategory() {
        const tagNamespaceArray = this.elements.selectBox.dataset.tagNamespace.split('/');
        return tagNamespaceArray[tagNamespaceArray.length - 1];
    }

    /**
     *
     * getAffinityValue
     */
    getAffinityValue() {
        if (this.localStorageAffinities) {
            return this.localStorageAffinities[this.getAffinityCategory()].name;
        }

        return null;
    }

    /**
     *
     * Checks if an affinity exists for a user.
     */
    isKnownUser() {
        return (
            this.localStorageAffinities
            && this.localStorageAffinities[this.getAffinityCategory()]
        );
    }

    /**
     * Pushes the selected value to the data layer.
     */
    pushToDataLayer(value, name) {
        const affinityCategory = value.split('/')[1];
        const eventObject = {
            event: 'affinity',
            category: affinityCategory,
            name,
            value,
        };

        window.digitalData.push(eventObject);
        const affinitiesObj = JSON.parse(window.localStorage.getItem('affinity')) || {};
        affinitiesObj[affinityCategory] = eventObject;
        window.localStorage.setItem('affinity', JSON.stringify(affinitiesObj));
    }

    /**
     * Initialize Component
     */
    init() {
        this.useCustomSelect();
        this.addEventListeners();
    }
}

registerComponent(`.${componentName}`, CTADropdown);
